import { render, staticRenderFns } from "./NotificationsCardItem.vue?vue&type=template&id=2fa06574&"
import script from "./NotificationsCardItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsCardItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports